export const DEBOUNCE_DELAY = 300;

export const SNACKBAR_DELAY = 3000;
